import React from 'react';

import { Flex, FlexProps, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { Branding } from 'components/Branding';
import { useTranslation } from 'react-i18next';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { navigateToLandingPage } from 'shared/utils/navigation';

interface PoweredByLabelProps extends FlexProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
}

export function PoweredByLabel({ smartAssistantVisualConfig, ...flexProps }: PoweredByLabelProps) {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const textColor = theme.other.getSecondaryReadableColor(smartAssistantVisualConfig.conversationBackgroundColor);
  const isBrandingLight = !theme.other.isDarkColor(textColor);

  return (
    <Flex {...flexProps}>
      <UnstyledButton onClick={() => navigateToLandingPage(true)} ml="auto" mr="auto" style={{ zIndex: 2 }}>
        <Flex direction="row" align="center" gap={5}>
          <Text size="0.70rem" color={textColor}>
            {t('SMART_ASSISTANT.POWERED_BY')}
          </Text>
          <Branding width={47} isLight={isBrandingLight} />
        </Flex>
      </UnstyledButton>
    </Flex>
  );
}
